<template>
    <div>
        <el-row>
            <el-form-item label="标签">
                <el-tag style="margin-left:0px;margin-right:10px;"
                    :key="tag"
                    v-for="tag in label"
                    closable
                    :disable-transitions="false"
                    @close="handleClose(tag)">
                    {{tag}}
                </el-tag>
                <el-input
                    class="input-new-tag"
                    v-if="inputVisible"
                    v-model="inputValue"
                    ref="saveTagInput"
                    size="small"
                    @keyup.enter.native="handleInputConfirm"
                    @blur="handleInputConfirm"
                >
                </el-input>
                <el-button v-else  size="small" @click="showInput">+ New Tag</el-button>
            </el-form-item>
        </el-row>
    </div>
</template>

<script>
    export default {
        props:{

            dadLabel:{
                type:Array
            }
        },
        data() {
            return {
                //增添标签

                // label:[],
                inputVisible: false,
                inputValue: "",
            }

        },
        created() {

        },

        computed:{
            label(){
                return this.dadLabel
            }
        },
        methods: {

            //标签的创建与删除
            //删除标签
            handleClose(tag) {
                this.label.splice(this.label.indexOf(tag), 1);
            },
            //创建标签时输入框
            showInput() {
                this.inputVisible = true;
                this.$nextTick(() => {
                    this.$refs.saveTagInput.$refs.input.focus();
                });
            },
            //创建标签确定
            handleInputConfirm() {
                let inputValue = this.inputValue;
                if (inputValue) {
                    this.label.push(inputValue);
                }
                this.inputVisible = false;
                this.inputValue = '';
                this.$emit('getLabelFromSon',this.label)
            }
        }
    }
</script>

<style scoped>

    .button-new-tag {
        margin-left: 10px;
        height: 30px;
        line-height: 30px;
        padding-top: 0;
        padding-bottom: 0;
    }
    .input-new-tag {
        width: 90px;
        margin-left: 10px;
        vertical-align: bottom;
    }
    .el-dialog .el-dialog__body .el-button--small{
        width: 85px;
        height: 22px;
        line-height: 15px;
        border-radius: 7px;
        color: white;
        font-size: 14px;
        padding: 3px;
        background-color: rgb(24,144,255);
    }
</style>
